import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
} from '@mui/material';
import { motion } from 'framer-motion';

const strategies = [
  {
    title: 'Market Leadership',
    description: 'Geomaps is establishing itself as the leading geospatial solutions provider in East, Central, and West Africa by delivering innovative GIS, AI, and remote sensing technologies tailored to diverse industries. Our commitment to data accuracy, scalability, and sustainable practices empowers sectors like land management, urban planning, and agriculture to drive economic growth and informed decision-making.',
  },
  {
    title: 'Digital Evolution',
    description: 'Geomaps is leading the digital transformation of mapping and spatial data analysis by integrating advanced technologies like GIS, AI, remote sensing, and cloud platforms. Our innovative solutions simplify complex workflows and enable businesses, governments, and organizations to make data-driven decisions with accuracy and efficiency, empowering sectors such as urban planning, agriculture, and infrastructure development.',
  },
  {
    title: 'Sustainable Growth',
    description: 'Geomaps is committed to long-term value creation by balancing economic, social, and environmental factors, ensuring our solutions drive business success while benefiting communities and ecosystems. By leveraging innovative technologies, promoting resource efficiency, and supporting sustainable projects, we aim to create lasting impact, foster resilient partnerships, and build a future where business and environmental stewardship thrive together.',
  },
];

const Strategy = () => {
  return (
    <Box>
      {/* Custom Hero Section */}
      <Box
        sx={{
          position: 'relative',
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'center',
          paddingTop: { xs: '160px', md: '180px' },
          paddingBottom: '60px',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/images/innovation.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 0,
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#000',
            opacity: 0.7,
            zIndex: 1,
          },
        }}
      >
        <Container sx={{ position: 'relative', zIndex: 2 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              color="white"
              sx={{
                fontSize: { xs: '2.5rem', md: '4rem' },
                fontWeight: 700,
                mb: 2,
              }}
            >
              Our Strategy
            </Typography>
            <Typography
              variant="h5"
              color="white"
              sx={{
                maxWidth: '800px',
                opacity: 0.9,
              }}
            >
              Building a sustainable future through strategic innovation
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* Content Section */}
      <Box sx={{ py: 12, backgroundColor: '#fff' }}>
        <Container>
          <Grid container spacing={4}>
            {strategies.map((strategy, index) => (
              <Grid item xs={12} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                >
                  <Card sx={{ p: 4, height: '100%' }}>
                    <Typography variant="h4" gutterBottom color="primary">
                      {strategy.title}
                    </Typography>
                    <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                      {strategy.description}
                    </Typography>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Strategy; 